import { useState } from 'react';
import { Button, Dropdown, Icon, type MenuItemType } from 'ui';
import type { MessageDirection } from '../../../../types';

type P = {
  className?: (isOpen: boolean) => string | undefined;
  direction: MessageDirection;
  items: MenuItemType[];
};

const ChatMessageActionsDropdown = ({ className, direction, items }: P) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      classNames={{
        itemContent: 'chat-message-actions-dropdown__item-content',
      }}
      menu={{
        className: 'chat-message-actions-dropdown__menu',
        items,
      }}
      onOpenChange={setIsOpen}
      open={isOpen}
      placement={direction === 'incoming' ? 'bottomLeft' : 'bottomRight'}
      trigger={['click']}
    >
      <Button
        className={className?.(isOpen)}
        icon={<Icon icon="more-2-line" />}
        onClick={(event) => {
          event.stopPropagation();
        }}
        size="small"
        type="link-primary"
      />
    </Dropdown>
  );
};

export default ChatMessageActionsDropdown;
